import { useCallback } from 'react';

import {
  type ErrorBoundaryProps,
  TransactionModuleErrorBoundary,
} from '@/components/TransactionModule/ErrorBoundary';

import { useTradeModuleStore, type TradeModuleStore } from '../store';

const errorBoundarySelector = (state: TradeModuleStore) => ({
  dispatchCheckout: state.dispatchCheckout,
  sellInputFormatted: state.sellInput.formatted,
  buyInputFormatted: state.buyInput.formatted,
});

/** Connects the shared transaction-module error boundary to rewrite state. */
export function ModuleErrorBoundary(props: ErrorBoundaryProps) {
  const { dispatchCheckout, sellInputFormatted, buyInputFormatted } =
    useTradeModuleStore(errorBoundarySelector);
  const resetCheckout = useCallback(() => dispatchCheckout({ type: 'reset' }), [dispatchCheckout]);

  return (
    <TransactionModuleErrorBoundary
      {...props}
      sellInputFormatted={sellInputFormatted}
      buyInputFormatted={buyInputFormatted}
      resetCheckout={resetCheckout}
    />
  );
}
